const INVALID_FILE_NAME_CHARS = /[\\/:*?"<>|]/g;

export function sanitizeFileNamePart(value) {
    return String(value || '')
        .replace(INVALID_FILE_NAME_CHARS, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

export function buildExportFileName(reportName, target, extension) {
    const suffix = sanitizeFileNamePart(target);
    const ext = extension || 'xlsx';
    return suffix ? `${reportName} - ${suffix}.${ext}` : `${reportName}.${ext}`;
}

export function exportTargetLabel(title, address, point) {
    const trimmedTitle = sanitizeFileNamePart(title);
    if (trimmedTitle) return trimmedTitle;

    const trimmedAddress = sanitizeFileNamePart(address);
    if (trimmedAddress) return trimmedAddress;

    const lat = point && point.lat;
    const lng = point && point.lng;
    if (typeof lat === 'number' && typeof lng === 'number') {
        return `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
    }

    return '';
}
